// extracted by mini-css-extract-plugin
export default {"bannerGoBackContainer":"preview-back_bannerGoBackContainer","bannerGoBackLink":"preview-back_bannerGoBackLink","bannerGoBackHide":"preview-back_bannerGoBackHide"};